(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery-rework"] && !Shopify.designMode) return;
  try {
    
(function(){
  console.log("hey");
  const gallery = document.querySelector('.mw-image-gallery');
  console.log("2")
  gallery.scrollLeft = gallery.children[2].offsetLeft;
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-row"] && !Shopify.designMode) return;
  try {
    
  const imageRow = document.querySelector('.image-row');
  const images = imageRow.querySelectorAll('img');
  
  // Set starting point at halfway in
  const setStartingPoint = () => {
    const halfway = (images.length / 2) - 1;
    imageRow.scrollLeft = imageRow.children[halfway].offsetLeft;
  };
  imageRow.children[images.length-1].addEventListener('load', setStartingPoint);

  // Mouse drag functionality
  let isDown = false;
  let startX;
  let scrollLeft;

  const startDrag = (e) => {
    isDown = true;
    imageRow.classList.add('active');
    startX = e.pageX - imageRow.offsetLeft;
    scrollLeft = imageRow.scrollLeft;
  };

  const stopDrag = () => {
    isDown = false;
    imageRow.classList.remove('active');
  };

  const handleDrag = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - imageRow.offsetLeft;
    const walk = (x - startX) * 3;
    imageRow.scrollLeft = scrollLeft - walk;
  };

  imageRow.addEventListener('mousedown', startDrag);
  imageRow.addEventListener('mouseleave', stopDrag);
  imageRow.addEventListener('mouseup', stopDrag);
  imageRow.addEventListener('mousemove', handleDrag);

  // Scroll button functionality
  const leftScrollButton = document.getElementById("leftScroll");
  const rightScrollButton = document.getElementById("rightScroll");

  const rollLeft = () => {
    const last = imageRow.lastElementChild.cloneNode(true);
    imageRow.prepend(last);
    imageRow.lastElementChild.remove(); 
  };

  const rollRight = () => {
    const first = imageRow.firstElementChild.cloneNode(true);
    imageRow.appendChild(first);
    imageRow.firstElementChild.remove();
  };

  const scrollOver = (itemWidth, direction) => {
    const targetPosition = imageRow.scrollLeft + (direction * itemWidth);
    imageRow.scrollTo({
      left: targetPosition,
      behavior: 'smooth'
    });
  };
  
  leftScrollButton.onclick = () => {
    rollLeft();
    // TODO can we prevent skipping for when first child is really wide?
    scrollOver(imageRow.firstElementChild.offsetWidth, -1);
  };

  rightScrollButton.onclick = () => {
    rollRight();
    // TODO can we prevent skipping for when first child is really wide?
    scrollOver(imageRow.firstElementChild.offsetWidth, 1);
  };

  } catch(e) { console.error(e); }
})();
})();
